const getDefaultsFromPostinstall = () => ({
  "config": {
    "apiKey": "AIzaSyB_Ttp8sb80ykt_OdgXdGk61cXzgfFCnZk",
    "appId": "1:294969617102:web:08786a57e5dc53cc313e9f",
    "authDomain": "parkour-base-project.firebaseapp.com",
    "databaseURL": "https://parkour-base-project.firebaseio.com",
    "messagingSenderId": "294969617102",
    "projectId": "parkour-base-project",
    "storageBucket": "parkour-base-project.appspot.com"
  },
  "emulatorHosts": {}
});
export { getDefaultsFromPostinstall };